import { Component, AfterViewInit, Input, ElementRef, ViewChild, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';

import { IconCodeTextInputModel } from './icon-code-text-input.model';

import { GetIconListService } from './api-services/get-icon-list.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

/**
 *　アイコンコードテキストインプットクラス
 *
 * @export
 * @class IconCodeTextInputComponent
 * @implements {AfterViewInit}
 * @implements {OnChanges}
 */
@Component({
  selector: 'app-icon-code-text-input',
  templateUrl: 'icon-code-text-input.component.html',
  styleUrls: ['icon-code-text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: IconCodeTextInputComponent,
      multi: true,
    },
    {
      provide: GetIconListService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub) => {
        return new GetIconListService(plessHttp, dialogService);
      },
      deps: [PlessHttp, PlessDialogServiceSub]

    },
  ]
})
export class IconCodeTextInputComponent implements AfterViewInit, OnInit, OnChanges {

  /** テキストインプットの参照 */
  @ViewChild('inputText', { static: true }) inputText: ElementRef;
  @Input() public subid: string = null;
  /** 値 */
  @Input() text: string = <string>'';
  /** 初期フォーカス項目 */
  @Input() initFocusItem: any = null;
  /** 配置区分 */
  @Input() blank: any = null;
  /** アイコン名称フィールド */
  @Input() iconNameField: any = null;

  // レイアウト系の変数
  @Input() left: number = <number>0;
  @Input() top: number = <number>0;
  @Input() width: number | string;
  @Input() height: number = <number>20;
  @Input() tabindex: number = <number>-1;
  @Input() forcedEnabledMode: string = null;
  @Input() autofocus: boolean = <boolean>false;
  @Input() disabled: boolean = <boolean>false;

  /** 値 */
  public textValue: string = <string>'';

  /** アイコンコード */
  public selectedIconCode: string = <string>'';
  /** アイコン名称 */
  public selectedIconName: string = <string>'';
  /** アイコン区分 */
  public selectedIconDiv: string = <string>'';
  /** 配置区分 */
  public selectedArrangeDiv: string = <string>'';

  /** アイコンコードテキストインプットモデル */
  public model: IconCodeTextInputModel = new IconCodeTextInputModel();

  private _initFocusItem: any = null;

  private _arrangeDiv: string = <string>'';

  /**
   *Creates an instance of IconCodeTextInputComponent.
   * @param {GetIconListService} getIconListService アイコンコードリストを取得サービス
   * @param {ElementRef} elementRef
   * @memberof IconCodeTextInputComponent
   */
  constructor(
    private getIconListService: GetIconListService,
    public elementRef: ElementRef
  ) {
  }

  /**
   * 初期処理
   *
   * @memberof IconCodeTextInputComponent
   */
  ngOnInit(): void {
    this.inputText.nativeElement.setAttribute('id', this.subid + '_sub');
    this.inputText.nativeElement.setAttribute('forcedEnabledMode', this.forcedEnabledMode);
  }

  /**
   * ロード完了時
   *
   * @memberof IconCodeTextInputComponent
   */
  ngAfterViewInit(): void {
    // テキストインスタンス設定
    this.model.iconCodeTextInput = this;

    // イベント発行
    const vo: any = new Object();
    vo['arrangeDiv'] = this._arrangeDiv;
    this.getIconListService.execute(this.model, vo);
  }

  /**
   * 値変更時イベント
   *
   * @param {SimpleChanges} changes 変更イベント
   * @memberof MediaGroupComboBoxComponent
   */
  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach((propName) => {
      switch (propName) {
        case 'text':
          if (changes.text.currentValue.length > 0) {
            this.textValue = PlessViewUtilsSub.zeroPadding(3, changes.text.currentValue);
          } else {
            this.textValue = '';
          }

          if (this.model.completeUpdateIconCodeList) {
            // 変更イベント処理実行
            this.changeIconCodeHandler();
          }
          break;
        case 'initFocusItem':
          this._initFocusItem = changes.initFocusItem.currentValue;
          break;
        case 'arrangeDiv':
          this._arrangeDiv = changes.arrangeDiv.currentValue;
          break;
      }
    });
  }

  /**
   * フォーカスアウトイベント
   *
   * @memberof IconCodeTextInputComponent
   */
  public onFocusOut(event: any): void {
    // アイコンコードのパディング
    if (this.model.completeUpdateIconCodeList) {
      if (this.textValue.length > 0) {
        this.textValue = PlessViewUtilsSub.zeroPadding(3, this.textValue);
        setTimeout(() => {
          if (null !== event.relatedTarget) {
            event.relatedTarget.focus();
          }
        });
      }
    }
  }

  /**
   * アイコンコード有効有無を返却する
   *
   * @returns {boolean} Boolean:True有効、False無効
   * @memberof IconCodeTextInputComponent
   */
  public isValidIconCode(): boolean {
    if (this.selectedIconName.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * アイコンコード変更時の処理を行う。
   *
   * @returns {void}
   * @memberof IconCodeTextInputComponent
   */
  public changeIconCodeHandler(): void {
    if (this.iconNameField != null) {
      if (this.iconNameField.constructor === HTMLLabelElement) {
        this.iconNameField.innerText = '';
      } else if (this.iconNameField.constructor === HTMLInputElement) {
        this.iconNameField.value = '';
      } else if (this.iconNameField.constructor === HTMLTextAreaElement) {
        this.iconNameField.value = '';
      }
    }
    this.selectedIconCode = '';
    this.selectedIconName = '';
    this.selectedIconDiv = '';
    this.selectedArrangeDiv = '';

    if (null !== this.model.iconList) {
      for (let i = Number(0); i < this.model.iconList.length; i++) {
        if (Number(this.model.iconList[i].IconCode) === Number(this.textValue)) {
          this.selectedIconCode = this.model.iconList[i].IconCode;
          this.selectedIconName = this.model.iconList[i].IconName;
          this.selectedIconDiv = this.model.iconList[i].IconDiv;
          this.selectedArrangeDiv = this.model.iconList[i].ArrangeDiv;

          // iconNameFieldが設定されてない場合は処理を中断する
          if (this.iconNameField != null) {
            if (this.iconNameField.constructor === HTMLLabelElement) {
              this.iconNameField.innerText = this.model.iconList[i].IconName;
            } else if (this.iconNameField.constructor === HTMLInputElement) {
              this.iconNameField.value = this.model.iconList[i].IconName;
            } else if (this.iconNameField.constructor === HTMLTextAreaElement) {
              this.iconNameField.value = this.model.iconList[i].IconName;
            }
          }
          return;
        }
      }
    }
    if (this._initFocusItem != null) {
      if (this.initFocusItem instanceof HTMLElement) {
        this.initFocusItem.focus();
      } else {
        // 参照先の型がElementでない(Component)ならComponent内の要素を見て最初のinput,textarea,selectElementにフォーカスをあてる
        for (const child of this.initFocusItem.elementRef.nativeElement.children) {
          if (child instanceof HTMLInputElement || child instanceof HTMLTextAreaElement || child instanceof HTMLSelectElement) {
            child.focus();
            break;
          }
        }
      }
      this._initFocusItem = null;
    }
  }

  /**
   * setFocusOverride※テキスト選択解除の為
   *
   * @memberof IconCodeTextInputComponent
   */
  public setFocus(): void {
    this.inputText.nativeElement.focus();
  }

}
